// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { HTMLColors } from '@Constants/colors';
import { IconBoolean } from '@Atoms/Info/IconBoolean/IconBoolean';
import { useLocalMessage } from '@Helpers/locale';
import { ICONS } from '@Constants/iconsApp';

interface IsFlagProps {
    value: boolean;
    onClick?: () => void;
    readOnly?: boolean;
}

export const IsFlag = ({ value, onClick, readOnly = false }: IsFlagProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <IconBoolean
            icon={<ICONS.FlagOutlined />}
            value={value}
            onClick={onClick}
            readOnly={readOnly}
            onTrue={{ color: HTMLColors.YELLOW, icon: <ICONS.FlagFilled /> }}
            label={i('common.flag')}
        />
    );
};
